var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.9L14.4 13.5L13.131 12.231L14.553 10.8H9.846C9.54 13.59 7.812 15.948 5.4 17.145C5.364 18.621 4.176 19.8 2.7 19.8C1.206 19.8 0 18.594 0 17.1C0 15.606 1.206 14.4 2.7 14.4C3.555 14.4 4.302 14.805 4.797 15.426C6.507 14.499 7.731 12.807 8.019 10.8H5.229C4.86 11.844 3.87 12.6 2.7 12.6C1.206 12.6 0 11.394 0 9.9C0 8.406 1.206 7.2 2.7 7.2C3.87 7.2 4.86 7.956 5.238 9H8.028C7.74 6.993 6.507 5.31 4.797 4.374C4.302 4.995 3.555 5.4 2.7 5.4C1.206 5.4 0 4.194 0 2.7C0 1.206 1.206 0 2.7 0C4.176 0 5.364 1.179 5.391 2.655C7.803 3.852 9.531 6.21 9.837 9H14.544L13.122 7.569L14.4 6.3L18 9.9Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisual);
export default __webpack_public_path__ + "static/media/visual.78231ec0.svg";
export { ForwardRef as ReactComponent };